var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrows({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.2689 0.0762438C7.10623 -0.0254146 6.89919 -0.0254146 6.73652 0.0762438C6.57385 0.177902 6.48443 0.36317 6.50659 0.552637V4.99906C6.50949 5.12924 6.56462 5.2529 6.65976 5.34262C6.75155 5.43818 6.87968 5.49095 7.0127 5.48797H11.501C11.7769 5.48797 12.0005 5.26612 12.0005 4.99245C12.0005 4.71879 11.7769 4.49694 11.501 4.49694L11.4877 4.50354H8.20471L10.8684 1.8608C11.0423 1.74895 11.1285 1.5422 11.0851 1.34117C11.0416 1.14014 10.8776 0.986607 10.6728 0.955291C10.468 0.923975 10.265 1.02139 10.1625 1.20011L7.49882 3.84286V0.552637C7.52099 0.36317 7.43157 0.177902 7.2689 0.0762438ZM5.1814 6.55167C5.1226 6.52603 5.05916 6.51254 4.99494 6.51203H0.499933C0.224097 6.51203 0.000488281 6.73388 0.000488281 7.00755C0.000488281 7.28121 0.224097 7.50306 0.499933 7.50306H3.78961L1.1259 10.1458C1.03278 10.2376 0.980408 10.3624 0.980408 10.4927C0.980408 10.6229 1.03278 10.7478 1.1259 10.8395C1.21862 10.9338 1.34613 10.9863 1.47885 10.9849C1.61141 10.9855 1.73863 10.9331 1.83179 10.8395L4.49549 8.19678V11.4474C4.47333 11.6368 4.56275 11.8221 4.72542 11.9238C4.88809 12.0254 5.09513 12.0254 5.2578 11.9238C5.42047 11.8221 5.50989 11.6368 5.48772 11.4474V7.00755C5.48693 6.94449 5.47568 6.88199 5.45443 6.82256C5.40188 6.70081 5.30411 6.60381 5.1814 6.55167Z",
    fill: "#0D1115"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrows);
export default __webpack_public_path__ + "static/media/Arrows.669ec4ac157d85d2614e4d5dfda65f01.svg";
export { ForwardRef as ReactComponent };